import React from "react";
import styles from "./Product.module.css";
import { IProductTechnicalSheetProps, ProductFilesView } from "@model/Products.model";
import useImageUploadRules from "../../../Logic/Functions/Hooks/useImageUploadRules";

const ProductTechnicalSheet: React.FC<IProductTechnicalSheetProps> = ({
    files,
}) => {
    const { buildImageSrc } = useImageUploadRules({
        mode: "file",
        maxFiles: 1,
        maxSizeMB: 10,
        requireAtLeastOne: false,
        enforceTotalSize: false,
    });

    return (
        <section className={styles.productSpecsSP} data-testid="product-techsheet">
            <h2 className={styles.sectionTitleSP}>Product related files:</h2>
            <div className={styles.productFilesList}>
                {files.map((file: ProductFilesView) => (
            <a
                href={buildImageSrc(file.fileUrl) ?? undefined}
                target="_blank"
                className={styles.technical}
                data-testid="product-techsheet-link"
            >
                {file.fileLabel}
            </a>

                ))}
            </div>
        </section>
    );
};

export default ProductTechnicalSheet;
